import { type LayoutProps } from "@chakra-ui/react";
import { CenteredQuote } from "components/quotes";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";
import React from "react";
import { AuraPlate } from "ui/plates";

type WarehouseQuoteProps = {
  textMaxW?: LayoutProps["maxW"];
};

export function WarehouseQuote({ textMaxW = "1000px" }: WarehouseQuoteProps) {
  const { warehouse } = useWarehouseCdp();

  if (!warehouse.quote) {
    return null;
  }

  return (
    <AuraPlate condensed variant={warehouse.color}>
      <CenteredQuote
        quoteText={warehouse.quote.text}
        author={{ name: warehouse.quote.authorName, job: warehouse.quote.authorJob }}
        company={{
          name: warehouse.quote.companyName ?? warehouse.name,
          logo: warehouse.quote.logoUrl,
        }}
        maxW={textMaxW}
      />
    </AuraPlate>
  );
}
